<template>
  <div id="Home">
    <advertisement />
    <div class="full_layout">
      <hot-products />
      <hot-information />
    </div>
  </div>
</template>
<script>
import Advertisement from "@/components/swiper/advertisement";
import HotProducts from '@/pages/home/hotproducts'
import HotInformation from '@/pages/home/hotinformation'
export default {
  name: 'index',
  components: { HotProducts, HotInformation, Advertisement },
  data() {
    return {}
  },
  mounted() {},
  created() {},
  methods: {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue